const ORIGINN = [
  {
    label: "广州",
    value: "1",
  },
  {
    label: "杭州",
    value: "2",
  },
];

const CITY = [
  {
    label: "广州",
    value: "1",
  },
  {
    label: "杭州",
    value: "2",
  },
  {
    label: "深圳",
    value: "3",
  },
  {
    label: "青岛",
    value: "4",
  },
];
const ACCEPT = {
  excel:
    ".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};
const BUSINESS_TYPE = {
  UNKNOWN: "0",
  STUDIO: "1",
  OFFLINE: "2",
  FACTORY: "3",
  ONLINE: "4",
};
// 营业类型{0:未知,1:独立工作室;2:线下档口;3:工厂;4:线上店铺;}
export { ORIGINN, CITY, ACCEPT, BUSINESS_TYPE };



// WEBPACK FOOTER //
// ./src/const/CommonConst.js